import React, { forwardRef, useCallback, useEffect, useState } from "react";
import { useController } from "react-hook-form";

import { StyledWrapper } from "./fileField.style";

import GenericInputField, {
  TYPES,
} from "../../../genericInputFields/genericInputField";
import useContestSettings from "../../../../hooks/useContestSettings";
import { parseXml } from "../../../../utils";
import removeCircle from "../../../../assets/icons/remove_circle.svg";
import useSolutionForm from "../../../../hooks/useSolutionForm";

// const FILE_EXTENSION = ['DOC', 'DOCX', 'PDF'];

const FileField = forwardRef(({ name, error }, ref) => {
  const {
    formMethods: { control },
  } = useSolutionForm();
  const { handleFileUpload, handleDeleteFileCallback, handleAddFileCallback } =
    useContestSettings();
  const { field } = useController({
    name,
    control,
  });
  const [files, setFiles] = useState(field.value || []);

  const handleFileChanged = useCallback(
    (file) => {
      if (!file) return;
      if (files.map((f) => f.filename).includes(file.name))
        return alert(
          "That file is already uploaded. Please choose another file.",
        );
      handleFileUpload(file, (data) => {
        const xml = parseXml(data);
        const key = xml.getElementsByTagName("Key")[0].textContent;
        handleAddFileCallback(key, (data) => {
          setFiles((prev) => [...prev, { ...data }]);
        });
      });
    },
    [name, files],
  );

  useEffect(() => {
    field.onChange(files);
  }, [files]);

  const handleDeleteFile = (key) => {
    handleDeleteFileCallback(key, () => {
      setFiles((prev) => prev.filter((file) => file.key !== key));
    });
  };

  return (
    <StyledWrapper ref={ref}>
      <GenericInputField
        type={TYPES.FILE}
        control={control}
        name={`${name}.key`}
        required={false}
        error={error}
        handleChange={handleFileChanged}
        accept={undefined}
        bottomMessage="We accept .doc, .docx, .pdf formats up to to 10 megabytes"
      />
      <div>
        {files.map((file, index) => (
          <div key={index}>
            <img
              src={removeCircle}
              alt="remove file"
              onClick={() => handleDeleteFile(file.key)}
            />
            {file.filename}
          </div>
        ))}
      </div>
    </StyledWrapper>
  );
});
FileField.displayName = "FileField";

export default FileField;
